import Lottie from "lottie-react";
import React from "react";

import * as procLoadingAnimation from "../../media/lottieFiles/proc-loading-01.json";

type LottieLoadingProps = {
  hideText?: boolean;
};

export const LottieLoading: React.FC<LottieLoadingProps> = ({
  hideText = false,
}) => {
  return (
    <div className={"flex w-full flex-col items-center justify-center"}>
      <div className={"h-1/5 w-1/5"}>
        <Lottie animationData={procLoadingAnimation} loop={true} />
      </div>

      {!hideText && (
        <div className={"font-extrabold opacity-30"}>Loading ...</div>
      )}
    </div>
  );
};
